<!-- Target element container -->
<div
  #targetElement
  class="target absolute left-0 top-0"
  style="transform-origin: 0 0"
  nrcDragAndDrop
  nrcResize
  nrcAlignmentGuide
  [style.z-index]="zIndex + Z_INDEX_LAYER_SPACING"
  [targetContainerRef]="parentContainerRef"
  [contentElement]="contentElement"
  [boundingBox]="boundingBox"
  [isEditMode]="isEditMode"
  [isDragDisabled]="!isEditMode || !isResizable"
  [isResizeDisabled]="!isEditMode || !isResizable"
  [mode]="currentMode() === resizeMode.TRANSFORM ? 'transform' : 'resize'"
  [isLocked]="isLocked"
  [activeCorner]="activeResizeCorner()"
  [currentCorners]="currentCornersForDirective()"
  [aspectLocked]="isAspectLocked()"
  [aspectRatio]="aspectRatio()"
  [contentElement]="contentElement"
  [enableResizeObserver]="true"
  (transformEvent)="onDirectiveTransform($event)"
  (resizeEvent)="onDirectiveResize($event)"
  (dragStarted)="isDragging.set(true)"
  (dragEnded)="onDirectiveDragEnded()"
  (cornersScaled)="onCornersScaled($event)"
  (dragPositionChanged)="onDragPositionChange($event)"
>
  <!-- Content area that gets matrix3d transforms -->
  <div
    #contentElement
    class="content w-full h-full"
    style="transform-origin: 0 0"
  >
    <!-- Projected content goes here -->
    <ng-content></ng-content>
  </div>

  <!-- Overlay: NOT transformed (sits above content) -->
  <div
    #overlayElement
    class="overlay absolute inset-0 pointer-events-none"
    [class.block]="showOverlay()"
    [class.hidden]="!showOverlay()"
    [style.z-index]="zIndex + Z_INDEX_LAYER_SPACING"
  >
    <!-- Corner handles -->
    @for (corner of cornerHandles(); track $index) {
      <div
        class="handle absolute w-3 h-3 -m-1.5 bg-white rounded-full pointer-events-auto cursor-grab border-2 border-blue-600"
        style="box-shadow: 0 2px 10px rgba(0,0,0,.45), 0 0 0 2px rgba(17,24,39,.7) inset"
        data-overlay-ui="corner-handle"
        [attr.data-corner]="corner.id"
        [style.left]="corner.x + 'px'"
        [style.top]="corner.y + 'px'"
        [style.z-index]="zIndex + Z_INDEX_LAYER_SPACING"
        (pointerdown)="onCornerDragStart($event, $index)"
      ></div>
    }

    <!-- Floating menu -->
    <div
      #menuElement
      class="menu absolute flex flex-col items-center gap-2 pointer-events-auto"
      style="filter: drop-shadow(0 8px 18px rgba(0,0,0,.35))"
      data-overlay-ui="menu"
      [style.left]="menuPosition().x + 'px'"
      [style.top]="menuPosition().y + 'px'"
      [style.z-index]="zIndex + Z_INDEX_LAYER_SPACING"
    >

      <!-- Mode toggle button -->
      <div class="relative group">
        <button
          class="rounded-full cursor-pointer border bg-gray-900/70 backdrop-blur-sm flex items-center justify-center transition-all duration-200 hover:border-cyan-400"
          style="width: 1.75rem; height: 1.75rem"
          data-overlay-ui="menu-button"
          [class]="overlayUiConfig().modeBorderClass"
          (click)="toggleMode()"
          (mouseenter)="modeButtonHovered.set(true)"
          (mouseleave)="modeButtonHovered.set(false)"
        >
          <nrc-icon
            [name]="currentMode() === resizeMode.TRANSFORM ? 'transform-mode' : 'resize-mode'"
            [fillColor]="overlayUiConfig().modeIconColor"
            class="pointer-events-none"
            style="width: 1rem; height: 1rem"
          ></nrc-icon>
        </button>

        <nrc-tooltip
          [text]="currentMode() === resizeMode.TRANSFORM ? 'Resize Mode' : 'Transform Mode'"
          [tooltipTextTopside]="false"
          class="absolute z-20 w-20 transition-all scale-0 opacity-0 min-h-5 left-1/2 transform -translate-x-1/2 group-hover:opacity-100 group-hover:scale-100 top-full mt-2"
        ></nrc-tooltip>

      </div>

      <!-- Aspect ratio lock button - only show in resize mode with animation -->
      <div class="relative group">
        <div
          class="aspect-lock-container transition-all duration-300 ease-smooth overflow-hidden"
          [class.max-h-0]="currentMode() === resizeMode.TRANSFORM"
          [class.opacity-0]="currentMode() === resizeMode.TRANSFORM"
          [class.opacity-100]="currentMode() === resizeMode.RESIZE"
          [style.max-height]="currentMode() === resizeMode.RESIZE ? '1.75rem' : '0'"
        >
          <button
            class="rounded-full cursor-pointer border bg-gray-900/70 backdrop-blur-sm flex items-center justify-center transition-all duration-200 hover:border-cyan-400"
            style="width: 1.75rem; height: 1.75rem"
            data-overlay-ui="menu-button"
            [class]="overlayUiConfig().aspectBorderClass"
            [style.outline]="isAspectLocked() ? '2px solid rgba(6,182,212,.25)' : 'none'"
            (click)="isAspectLocked.set(!isAspectLocked())"
            (mouseenter)="aspectButtonHovered.set(true)"
            (mouseleave)="aspectButtonHovered.set(false)"
          >
            <nrc-icon
              name="link"
              [fillColor]="overlayUiConfig().aspectIconColor"
              class="pointer-events-none"
              style="width: 1rem; height: 1rem"
            ></nrc-icon>
          </button>
        </div>

        <nrc-tooltip
          [text]="isAspectLocked() ? 'Unlock Aspect Ratio' : 'Lock Aspect Ratio'"
          [tooltipTextTopside]="false"
          class="absolute z-20 w-12 transition-all scale-0 opacity-0 min-h-5 left-1/2 transform -translate-x-1/2 group-hover:opacity-100 group-hover:scale-100 top-full mt-2"
          [ngClass]="{ 'pointer-events-none': currentMode() === resizeMode.TRANSFORM }"
        ></nrc-tooltip>
      </div>
  </div>
</div>
